var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_69533",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_69533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83268 13.8334L14.7077 7.95835L13.541 6.79169L8.83268 11.5L6.45768 9.12502L5.29102 10.2917L8.83268 13.8334ZM9.99935 18.3334C8.84657 18.3334 7.76324 18.1145 6.74935 17.6767C5.73546 17.2395 4.85352 16.6459 4.10352 15.8959C3.35352 15.1459 2.7599 14.2639 2.32268 13.25C1.8849 12.2361 1.66602 11.1528 1.66602 10C1.66602 8.84724 1.8849 7.76391 2.32268 6.75002C2.7599 5.73613 3.35352 4.85419 4.10352 4.10419C4.85352 3.35419 5.73546 2.7603 6.74935 2.32252C7.76324 1.8853 8.84657 1.66669 9.99935 1.66669C11.1521 1.66669 12.2355 1.8853 13.2493 2.32252C14.2632 2.7603 15.1452 3.35419 15.8952 4.10419C16.6452 4.85419 17.2388 5.73613 17.676 6.75002C18.1138 7.76391 18.3327 8.84724 18.3327 10C18.3327 11.1528 18.1138 12.2361 17.676 13.25C17.2388 14.2639 16.6452 15.1459 15.8952 15.8959C15.1452 16.6459 14.2632 17.2395 13.2493 17.6767C12.2355 18.1145 11.1521 18.3334 9.99935 18.3334Z",
    fill: "#04B7B1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayCompleted);
export default __webpack_public_path__ + "static/media/PayCompleted.42639634bb0c37d7f961e6c1677f1217.svg";
export { ForwardRef as ReactComponent };